// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"415":"d8d80580","932":"5c39d6b2"}[chunkId] + ".js";
};